<template>
  <div>
    <div class="transform transition-all duration-150">
      <div class="px-3 md:px-6" v-if="!active_category" :key="1">
        <h1
          class="text-ontick-carbon-900 py-6 text-3xl font-bold dark:text-gray-300"
        >
          {{ data.pageName }}
        </h1>
        <swiper :options="options" class="h-36">
          <swiper-slide
            @click.native="activeCategory(item)"
            v-for="(item, index) in categories"
            :key="index"
            class="group relative h-36 cursor-pointer overflow-hidden rounded-xl shadow-xl"
          >
            <div
              class="h-full transform px-3 py-3 filter duration-200 hover:brightness-125"
              :class="
                $route.name !== 'Analistas XP'
                  ? 'bg-cover bg-center'
                  : 'bg-ontick-steel-500'
              "
              :style="`${
                $route.name !== 'Analistas XP'
                  ? `background-image: url(${item.category_image})`
                  : ''
              }`"
            >
              <div class="absolute inset-0">
                <img
                  v-if="$route.name === 'Analistas XP'"
                  :src="item.category_image"
                  alt=""
                  class="absolute right-0 h-full w-auto"
                />
                <div
                  class="from-ontick-graphite-500 absolute inset-0 bg-gradient-to-r to-transparent"
                ></div>
                <div
                  class="bg-ontick-graphite-500 absolute inset-0 opacity-40"
                ></div>
              </div>
              <!-- <div
                class="from-ontick-carbon-600 to-ontick-graphite-200 group-hover:from-ontick-blue-900 dark:to-ontick-graphite-400 absolute inset-0 w-full bg-gradient-to-tl opacity-70 mix-blend-normal transition-all duration-300 ease-in-out"
              ></div> -->
              <div
                class="absolute bottom-4 z-20 w-full -translate-y-16 transform space-y-2 py-3 transition-all duration-300 lg:translate-y-0 lg:group-hover:-translate-y-16"
              >
                <div class="absolute bottom-0 space-y-2">
                  <div class="h-6 w-6" v-if="$route.name === 'Analistas XP'">
                    <i
                      v-html="getInstitutionIcon(item.partner_institution)"
                      class="h-6 w-6"
                    ></i>
                  </div>
                  <h2
                    class="text-lg font-semibold !leading-none text-gray-50 dark:text-gray-300"
                  >
                    {{ item.category_name }}
                  </h2>
                </div>
                <p
                  class="absolute w-full pr-6 pt-2 text-xs text-gray-50 transition-all duration-200 group-hover:pt-2 group-hover:opacity-100 dark:text-gray-300 lg:pt-12 lg:opacity-0"
                >
                  {{ item.category_description }}
                </p>
              </div>
            </div>

            <!-- <h2 class="text-gray-300 font-semibold xl:text-2xl text-xl">
                {{ item.category_name }}
              </h2>
              <p class="text-gray-300 text-xs py-3 pr-6 absolute w-full">
                {{ item.category_description }}
              </p> -->
          </swiper-slide>
        </swiper>
      </div>
      <div
        v-else
        :key="2"
        class="h-full w-full bg-cover bg-center"
        :style="
          $route.name === 'Analistas XP'
            ? ''
            : `background-image: url(${selected.img})`
        "
      >
        <div
          class="from-ontick-carbon-900 to-ontick-graphite-500 absolute inset-0 w-full bg-gradient-to-t opacity-80"
        ></div>
        <div
          class="from-ontick-carbon-500 absolute inset-y-0 w-full bg-gradient-to-t"
        ></div>
        <carousel-ranking
          v-if="category.length > 0"
          :title="selected.name"
          :description="selected.description"
          :products="category"
          :details_index="details.index"
          @close="
            (category = []), (active_category = false), (card_minize = true)
          "
          @details="activeDetails"
        />
        <div
          v-show="loading"
          class="grid grid-cols-1 gap-6 px-6 pt-6 md:grid-cols-4"
        >
          <placeholder-card-component
            v-for="(item, index) in 4"
            :qtd="4"
            :key="index"
          />
        </div>

        <div class="relative" v-if="category.length == 0 && active_category">
          <button
            @click="
              (category = []), (active_category = false), (card_minize = true)
            "
            class="ml-6 mt-6 text-white"
          >
            <i v-html="$icons.arrow_left"></i>
          </button>
          <div class="p-6 text-gray-400" v-if="empty">
            {{ errorMsg }}
          </div>
        </div>
      </div>
    </div>

    <ontick-aero
      :active="active_details"
      @close="(active_details = false), (details.index = null)"
    >
      <product-component
        v-if="active_details"
        :active="active_details"
        :strategy_id="details.strategy"
        :product_id="details.product"
        :pagination="details.index"
        :index_last="categories.length - 1"
        @close="(active_details = false), (details.index = null)"
        @pagination="nextDetails"
      />
    </ontick-aero>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { mapState } from "vuex";

export default {
  components: {
    Swiper,
    SwiperSlide,
    ProductComponent: () =>
      import("../../../pages/details/product.component.vue"),
    CarouselRanking: () =>
      import("../highlights/marketplace-highlights-carousel.component.vue"),
    PlaceholderCardComponent: () =>
      import(
        "../../../../../shared/components/placeholder/placeholder-card.component.vue"
      ),
  },

  props: {
    categories: {
      type: Array,
      default: [],
    },
  },

  data() {
    return {
      errorMsg: "Por enquanto, essa categoria está vazia.",
      empty: false,
      active_category: false,
      selected: { name: "", description: "", img: "" },
      category: [],
      active_details: false,
      details: { strategy: 0, product: 0, index: 0 },
      card_minize: true,

      loading: false,

      options: {
        slidesPerView: 4,
        centeredSlides: false,
        spaceBetween: 25,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 25,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          320: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
        },
      },
    };
  },

  computed: {
    ...mapState({
      accountTypes: (state) => state.accountTypes,
    }),
    data() {
      if (this.$route.name === "Analistas XP") {
        return {
          pageName: "Analistas XP",
        };
      } else {
        return {
          pageName: "Destaques",
        };
      }
    },
  },

  methods: {
    getInstitutionIcon(institution) {
      switch (institution) {
        case "XP":
          return this.$icons.xp;
        case "CLEAR":
          return this.$icons.clear;
        case "RICO":
          return this.$icons.rico_badge;
        default:
          return this.$icons.logo;
      }
    },
    activeDetails(detail) {
      this.details = { ...detail };
      this.active_details = true;
    },
    enter(el, done) {
      const tl = new TimelineMax({
        onComplete: done,
      });

      tl.set(el, {
        x: window.innerWidth * 0.5,
        scale: 0.8,
        transformOrigin: "50% 50%",
      });

      tl.to(el, 0.5, {
        x: 0,
        ease: Power4.easeOut,
      });

      tl.to(el, 0.5, {
        scale: 1,
        ease: Power4.easeOut,
      });
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        0.5,
        {
          autoAlpha: 0,
        },
        {
          autoAlpha: 0,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },

    nextDetails(type) {
      if (
        this.details.index != 0 ||
        this.details.index != this.category.length - 1
      ) {
        this.details.index =
          type == "next" ? this.details.index + 1 : this.details.index - 1;
        this.details.product = this.category[this.details.index].product_id;
        this.details.strategy =
          this.category[this.details.index].strategies[0].strategy_id;
      }
    },
    activeCategory(category) {
      this.$nextTick(() => {
        this.active_category = true;
        this.selected.name = category.category_name;
        this.selected.description = category.category_description;
        this.selected.img = category.category_image;
      });
      let eventValue = `(${this.accountTypes.selectedAccount.broker_name} - ${this.accountTypes.selectedAccount.account_number}) ${category.category_id} - ${category.category_name}`;
      this.$gtm.trackEvent({
        event: "interaction", // Event type [default = 'interaction'] (Optional)
        category: "Categoria",
        action: "click",
        label: "Categoria aberta",
        value: eventValue,
      });

      this.loading = true;
      this.$api
        .get(
          `${this.$endpoint.GET_MARKETPLACE_CATEGORY}/${category.category_id}/${category.img_id}?account_id=${sessionStorage.aid}`
        )
        .then((response) => {
          this.empty = false;
          this.category = response.data;
        })
        .catch((err) => {
          this.category = [];
          this.empty = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // activeDetails(strategy, product, index) {
    //   this.$emit("active_details", strategy, product, index);
    // },
  },
};
</script>
